import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/chevron-left.svg'


const _withScopeId = n => (_pushScopeId("data-v-34e93ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  "aria-hidden": "true"
}, null, -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "nav-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nav", { underline: $props.shouldShowUnderline }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!$props.shouldHideBackButton)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "img-back-btn",
            type: "button",
            "aria-label": "뒤로가기",
            onClick: $setup.onClickBack
          }, [..._hoisted_3]))
        : (!$props.shouldHideCloseButton)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "img-close-btn",
              type: "button",
              "aria-label": "닫기",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClickClose')))
            }, [
              _createVNode($setup["InlineSvg"], {
                src: require('@/assets/icons/x-icon.svg'),
                "aria-hidden": "true"
              }, null, 8 /* PROPS */, ["src"])
            ]))
          : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-title-wrapper", { 'modal-title': $props.shouldHideBackButton }])
      }, [
        _renderSlot(_ctx.$slots, "navTitleExtra", {}, undefined, true),
        _createElementVNode("p", _hoisted_4, _toDisplayString($props.title), 1 /* TEXT */)
      ], 2 /* CLASS */),
      _renderSlot(_ctx.$slots, "rightButton", {}, undefined, true)
    ])
  ], 2 /* CLASS */))
}